import { render, staticRenderFns } from "./GeoData.vue?vue&type=template&id=5e01d76c&scoped=true"
import script from "./GeoData.vue?vue&type=script&lang=js"
export * from "./GeoData.vue?vue&type=script&lang=js"
import style0 from "./GeoData.vue?vue&type=style&index=0&id=5e01d76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e01d76c",
  null
  
)

export default component.exports